import { useRef, useLayoutEffect, useState, MutableRefObject, MouseEvent, MouseEventHandler } from 'react';
import { createPortal } from 'react-dom';
import { Transforms } from 'slate';
import { ReactEditor, RenderElementProps, useSlate } from 'slate-react';
import { isNote } from '../utils/notes';

interface NoteMenuProps {
  reference: MutableRefObject<HTMLElement>;
  element: RenderElementProps['element'];
  onMouseEnter?: MouseEventHandler<HTMLDivElement>;
  onMouseLeave?: MouseEventHandler<HTMLDivElement>;
}

export const NoteMenu = ({ reference, element }: NoteMenuProps) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const editor = useSlate();

  useLayoutEffect(() => {
    const el = ref.current;

    if (!el) {
      return;
    }

    const target = reference.current;
    const parent = target.offsetParent as HTMLElement;

    el.style.opacity = '1';
    el.style.top = `${target.offsetTop + parent.offsetTop + 40}px`;
    el.style.left = `${target.offsetLeft + parent.offsetLeft + 645}px`;
  });

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    e.preventDefault();
    console.debug('Click! Delete note', ReactEditor.findPath(editor, element));
    Transforms.removeNodes(editor, {
      at: ReactEditor.findPath(editor, element),
      match: (node) => isNote(node),
    });
  };

  return createPortal(
    <div ref={ref} className="comment--add-coment">
      <i onMouseDown={handleClick} className="fa-regular fa-square-minus" />
    </div>,
    document.body
  );
};

interface NoteInfoProps {
  reference: HTMLElement | null;
}

const NoteInfo = ({ reference }: NoteInfoProps) => {
  const ref = useRef<HTMLDivElement | null>(null);

  useLayoutEffect(() => {
    const el = ref.current;

    if (!el || !reference) {
      return;
    }

    const parent = reference.offsetParent as HTMLElement;

    el.style.opacity = '1';
    el.style.top = `${reference.offsetTop + parent.offsetTop}px`;
    el.style.left = `${reference.offsetLeft + parent.offsetLeft - 180}px`;
  });
  return createPortal(
    <div ref={ref} className="comment--add-coment">
      Note
    </div>,
    document.body
  );
};

export const Note = (props: RenderElementProps) => {
  const { attributes, element, children } = props;
  const [hovered, setHovered] = useState(false);
  const [mHovered, setMHovered] = useState(false);

  const showMenu = hovered || mHovered;

  return (
    <div {...attributes} className="note" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
      {!showMenu ? null : (
        <NoteMenu reference={attributes.ref} element={element} onMouseEnter={() => setMHovered(true)} onMouseLeave={() => setMHovered(false)} />
      )}
      <NoteInfo reference={attributes.ref.current} />
      {children}
    </div>
  );
};
